<template>
  <div class="base-control base-checkbox form-group">
    <input :disabled="disabled" ref="checkbox" class="styled-checkbox" :id="id" type="checkbox" :value="1" :checked="value" @change="onInput()">
    <label style="font-weight: normal;" class="mb-0" :for="id">{{ label }}</label>
  </div>
</template>

<script>

export default {
  name: 'BaseCheckbox',
  inject: ['$validator'],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    err: {
      type: Array,
      default: () => []
    },
    radius: {
      type: String,
      default: ''
    },
    inline: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    units: {
      type: Object,
      default: () => {}
    }
  },
  $_veeValidate: {
    value () {
      return this.$refs.input.value;
    },
    name () {
      return this.name;
    }
  },
  methods: {
    onInput () {
      this.$emit('input', !!this.$refs.checkbox.checked);
    },
    unitChange (unit) {
      this.$emit('input-unit', unit);
    }
  },
  data () {
    return {

    };
  },
  mounted () {
    if (this.value !== null && this.value !== '') {
      this.$validator.validateAll();
    }
  },
  computed: {
    id () {
      return 'base-checkbox-' + this._uid;
    },
    hasErrors () {
      return this.err && this.err.length > 0;
    },
    isOk() {
      let k = '';
      for (const key in this.fields) {
        k = key;
      }

      if (!this.fields[k] || !this.fields[k][this.name]) return false;
      return this.fields[k][this.name].validated && this.fields[k][this.name].valid;
    }
  }
};

</script>

<style>

</style>
